<ul>
  @for (name of element().law_firm_names; track name) {
    <li>{{ name }}</li>
  }
</ul>
